// import './../action/Vod.action';
import {
  INDEX_VOD_LIST,
  INDEX_VOD_ADD_LIST,
  VOD_LIST,
  VOD_LESSON_LIST,
  GET_VOD_LESSON_SRC,
  GET_VOD_TENCENT_APPID
} from "../type/Vod.type";

const defaultData = {
  subjectsVod: [],
  vodList: {
    courses: [],
    page: {}
  },
  vodLessonList: [],
  vodLessonSrc: {},
  appId: null
};

const Vod = (state = defaultData, action) => {
  let copyState = { ...state };
  switch (action.type) {
    case INDEX_VOD_LIST:
      copyState.subjectsVod = action.res.subjectsVod || [];
      return copyState;
    case INDEX_VOD_ADD_LIST:
      copyState.subjectsVod[action.res.activeKey].list = action.res.data;
      return copyState;
    case VOD_LIST:
      copyState.vodList = action.res;
      return copyState;
    case VOD_LESSON_LIST:
      copyState.vodLessonList = action.res;
      return copyState;
    case GET_VOD_LESSON_SRC:
      copyState.vodLessonSrc = action.res;
      return copyState;
    case GET_VOD_TENCENT_APPID:
      copyState.appId = action.res;
      return copyState;
    default:
      return copyState;
  }
};
export default Vod;



// WEBPACK FOOTER //
// ./src/redux/reducer/Vod.reducer.js